export default Object.freeze({
  defaultFont: 'HurmeGeometricSans2, "Open Sans", sans-serif',
  headingFont: 'NoeDisplay, "Open Sans", sans-serif',
  sizes: {
    default: 12,
    less: 13,
    normal: 14,
    mid: 16,
    big: 18,
    bigger: 22,
    link: 11,
  },
  bolder: 800,
  bold: 600,
  normal: 'normal',
  light: 300,
  lighter: 200,
  letterSpacing: {
    whole: 1,
    mid: 0.46,
    medium: 0.5,
  },
});
